import { render, staticRenderFns } from "./AdminPoster.vue?vue&type=template&id=4c1183e7"
import script from "./AdminPoster.vue?vue&type=script&lang=js"
export * from "./AdminPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports